// Subprocessors.js — published list per DPA § 8.2.

import React, { useEffect } from 'react';
import './Styling/LegalPage.css';

const TODAY = new Date().toISOString().slice(0, 10);

export default function Subprocessors() {
  useEffect(() => {
    document.title = "Subprocessors — MyEmployeeManual.com";
  }, []);

  return (
    <div className="legalPage">
      <div className="legalPage__container">
        <h1>Authorized Subprocessors</h1>
        <p className="legalPage__dates"><strong>Last Updated:</strong> {TODAY}</p>
        <p>
          This page lists the third-party service providers we engage to process Workforce Personal Information on our behalf, as required by our Data Processing Addendum (Exhibit B to the <a href="/tos">Terms of Service</a>, §&nbsp;8.2).
        </p>

        <table className="legalPage__table">
          <thead>
            <tr><th>Subprocessor</th><th>Location</th><th>Purpose</th></tr>
          </thead>
          <tbody>
            <tr><td>Amazon Web Services</td><td>United States</td><td>Application hosting, storage, backup</td></tr>
            <tr><td>Stripe</td><td>United States</td><td>Payment processing (does not process Workforce Personal Information)</td></tr>
            <tr><td>Google (Gmail API, Drive API)</td><td>United States</td><td>Transactional email delivery, document storage and conversion</td></tr>
            <tr><td>Supabase</td><td>United States</td><td>Database and account management</td></tr>
            <tr><td>Auth0 (Okta)</td><td>United States</td><td>Authentication and account login</td></tr>
            <tr><td>Vercel</td><td>United States</td><td>Front-end hosting and CDN</td></tr>
          </tbody>
        </table>

        <p>
          We will notify Clients of new Subprocessors at least thirty (30) days in advance by updating this page and sending email notice to the account-of-record address. To object to a new Subprocessor on reasonable data-protection grounds, write to <a href="mailto:legal@myemployeemanual.com">legal@myemployeemanual.com</a> within the notice period.
        </p>
      </div>
    </div>
  );
}
